import { render } from "./About.vue?vue&type=template&id=44dcdd5e&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=44dcdd5e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-44dcdd5e"

export default script